<template>
    <div class="form-container">
        <h2>{{ isEditing ? 'Update' : 'Add' }} Nursing Review</h2>
        <hr>

        <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>

        <form @submit.prevent="submitForm">
            <label>Review Note *</label>
            <textarea v-model="form.review_note" required></textarea>
            <div v-if="errors.review_note" class="error-message">{{ errors.review_note[0] }}</div>

            <label>Reviewed Date *</label>
            <input type="date" v-model="form.reviewed_at" required />
            <div v-if="errors.reviewed_at" class="error-message">{{ errors.reviewed_at[0] }}</div>

            <label>Nurse *</label>
            <select v-model="form.nurse_id" required>
                <option disabled value="">Select Nurse</option>
                <option v-for="nurse in nurses" :key="nurse.id" :value="nurse.id">{{ nurse.user.name }}</option>
            </select>
            <div v-if="errors.nurse_id" class="error-message">{{ errors.nurse_id[0] }}</div>

            <div class="btn-group mt-4">
                <button type="submit" class="btn btn-sm btn-success">{{ isEditing ? 'Update' : 'Save' }}</button>
                <button type="button" class="btn btn-sm cancel-btn" @click="$router.back()">Cancel</button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    props: ['phase_determination_id', 'id'],
    data() {
        return {
            isEditing: false,
            form: {
                phase_determination_id: this.phase_determination_id,
                review_note: '',
                reviewed_at: this.getCurrentDate(),
                nurse_id: '',
            },
            nurses: [],
            errors: {},
            errorMessage: null,
        };
    },
    async mounted() {
        await this.fetchNurses();
        if (this.id) {
            this.isEditing = true;
            await this.fetchFormData();
        }
    },
    methods: {
        async fetchNurses() {
            try {
                const res = await this.$api.get('/nurses');
                this.nurses = res.data;
            } catch (err) {
                this.errorMessage = 'Failed to load nurses.';
            }
        },
        getCurrentDate() {
            const today = new Date();
            return today.toISOString().split('T')[0];  // Output: 'YYYY-MM-DD'
        },
        async fetchFormData() {
            try {
                const res = await this.$api.get(`/nursing-review/${this.id}`);
                this.form = {
                    ...res.data,
                    phase_determination_id: res.data.phase_determination_id, // ensure it's set
                    reviewed_at: res.data.reviewed_at?.split(' ')[0] || ''
                };

                console.log(this.form);
            } catch {
                this.errorMessage = 'Failed to load nursing review data.';
            }
        },
        async submitForm() {
            this.errors = {};
            this.errorMessage = null;
            try {
                if (this.isEditing) {
                    await this.$api.put(`/nursing-review/${this.id}`, this.form);
                } else {
                    await this.$api.post('/nursing-review', this.form);
                }

                this.$router.push({
                    name: 'PhaseDeterminationDetail',
                    params: { student_id: this.form.phase_determination.student_id }
                });
            } catch (err) {
                // console.log(err);
                if (err.response?.status === 422) {
                    this.errors = err.response.data.errors;
                } else {
                    this.errorMessage = 'Failed to save data. Please try again.';
                }
            }
        }
    }
};
</script>

<style scoped>
.form-container {
    max-width: 700px;
    margin: auto;
    padding: 20px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

label {
    display: block;
    margin-top: 15px;
    font-weight: bold;
}

input,
select,
textarea {
    width: 100%;
    padding: 8px;
    margin-top: 5px;
    box-sizing: border-box;
}

textarea {
    resize: vertical;
}

.error-message {
    color: red;
    font-size: 0.9em;
    margin-top: 4px;
}

.btn-group {
    display: flex;
    gap: 10px;
    margin-top: 20px;
}

button {
    min-width: 150px;
}
</style>